//const { all } = require("micromatch");

function getFocusableElements(container) {
  if (!container) return [];
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function updateVisiblePrice (wrapper) {
  const apluseCheckbox = wrapper.querySelector("#aplusproducts-cb")
  const giftBoxCheckbox = wrapper.querySelector("[data-gift-product-input]")

  const definitions = {
    "true true": "aplusGiftBoxCartPrice",
    "true false": "aplus_cart_price",
    "false true": "giftBoxCartPrice",
    "false false": "price-small-snip"
  }

  const key = `${apluseCheckbox?.checked ?? false} ${giftBoxCheckbox?.checked ?? false}`
  const priceId = definitions[key]

  wrapper.querySelectorAll('[data-price-value]').forEach((priceEl) => {
    const priceElId = priceEl.getAttribute('data-price-value')
    if (priceElId === priceId) {
      priceEl.classList.remove('hidden')
    } else {
      priceEl.classList.add('hidden')
    }
  });
}

const initPriceChangeListeners = (wrapper = document.querySelector('body')) => {
  wrapper.querySelectorAll('[data-gift-product-input]').forEach((checkbox) => {
    if (checkbox.classList.contains('initialized')) return
    checkbox.addEventListener('change', (e) => {
      updateVisiblePrice(e.target.closest('.product'))
      wrapper.querySelector('[data-gift-box-form]')?.classList.toggle('hidden', !e.target.checked)
    })
    checkbox.classList.add('initialized')
  });

  wrapper.querySelectorAll('#aplusproducts-cb').forEach((checkbox) => {
    if (checkbox.classList.contains('initialized')) return
    checkbox.addEventListener('change', (e) => {
      updateVisiblePrice(e.target.closest('.product'))
    })
    checkbox.classList.add('initialized')
  });
}

document.addEventListener('DOMContentLoaded', () => {
  updateVisiblePrice(document)
  initPriceChangeListeners()
})

function updateFakeCheckbox(cb) {
  document.getElementById('aplusFakeCheckbox')?.classList.toggle('text-white', !cb.checked)
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

document.querySelectorAll('img[data-hover]').forEach((im) => {
  im.addEventListener('mouseenter', (e) => {
    let hover_image = im.getAttribute('data-hover')
    let original_image = im.getAttribute('src')
    let hover_srcset = im.getAttribute('srcset-hover')
    let original_srcset = im.getAttribute('srcset')
    let hover_datasrcset = im.getAttribute('data-srcset-hover')
    let original_datasrcset = im.getAttribute('data-srcset')
    im.setAttribute('src', hover_image)
    im.setAttribute('data-hover', original_image)
    im.setAttribute('srcset-hover', original_srcset)
    im.setAttribute('srcset', hover_srcset)
    im.setAttribute('data-srcset-hover', original_datasrcset)
    im.setAttribute('data-srcset', original_datasrcset)
  })
  im.addEventListener('mouseleave', (e) => {
    let hover_image = im.getAttribute('data-hover')
    let original_image = im.getAttribute('src')
    let hover_srcset = im.getAttribute('srcset-hover')
    let original_srcset = im.getAttribute('srcset')
    let hover_datasrcset = im.getAttribute('data-srcset-hover')
    let original_datasrcset = im.getAttribute('data-srcset')
    im.setAttribute('src', hover_image)
    im.setAttribute('data-hover', original_image)
    im.setAttribute('srcset-hover', original_srcset)
    im.setAttribute('srcset', hover_srcset)
    im.setAttribute('data-srcset-hover', original_datasrcset)
    im.setAttribute('data-srcset', original_datasrcset)
  })
})


const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  // if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

document.addEventListener("DOMContentLoaded", (event) => {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true });
      this.input.addEventListener('change', this.onInputChange.bind(this));
      this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }
  
    quantityUpdateUnsubscriber = undefined;
  
    connectedCallback() {
      this.validateQtyRules();
      this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
    }
  
    disconnectedCallback() {
      if (this.quantityUpdateUnsubscriber) {
        this.quantityUpdateUnsubscriber();
      }
    }
  
    onInputChange(event) {
      this.validateQtyRules();
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  
  
    }
  
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        const buttonMinus = this.querySelector(".quantity__button[name='minus']");
        //buttonMinus.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        const buttonPlus = this.querySelector(".quantity__button[name='plus']");
        buttonPlus.classList.toggle('disabled', value >= max);
      }
    }
  }
  
  customElements.define('quantity-input', QuantityInput);
});

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    const value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    const value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    const opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute('data-provinces');
    const provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (let i = 0; i < provinces.length; i++) {
        const opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (let i = 0, count = values.length; i < values.length; i++) {
      const opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("DOMContentLoaded", (event) => {

      this.mainDetailsToggle = this.querySelector('details');
      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.bindEvents();
    });
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }
    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        /*!reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);*/
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      document.documentElement.classList.add('overflow-hidden');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    
    if (document.querySelector('.main-price-min-input') && document.querySelector('.main-price-max-input') ) {
      const minInput = document.querySelector('.main-price-min-input');
      const maxInput = document.querySelector('.main-price-max-input');
      const minRange = document.querySelector('.price-range-min');
      const maxRange = document.querySelector('.price-range-max');
      const rangeTrack = document.querySelector('.price-range-track');
      const MIN = +minInput.min || 0;
      const MAX = +maxInput.max || 100;
      const minValue = +minInput.value || MIN;
      const maxValue = +maxInput.value || MAX;
  
      minRange.value = minValue; 
      maxRange.value = maxValue; 

      const minPercent = ((minValue - MIN) / (MAX - MIN)) * 100;
      const maxPercent = ((maxValue - MIN) / (MAX - MIN)) * 100;
  
      rangeTrack.style.left = `${minPercent}%`;
      rangeTrack.style.width = `${maxPercent - minPercent}%`;
    }
  }

  closeMenuDrawer(event, elementToFocus = false) {
    document.documentElement.classList.remove('overflow-hidden');
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    document.addEventListener("DOMContentLoaded", (event) => {
      setTimeout(() => {
        this.mainDetailsToggle = this.querySelector('details');
        if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
          this.closeMenuDrawer();
      });
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));

  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
  
  }
}
customElements.define('modal-dialog', ModalDialog);

document.addEventListener('DOMContentLoaded', () => {
  class QuickAddThankYouModal extends ModalDialog {
    constructor() {
      super();
    }
    connectedCallback() {
      this.querySelectorAll('.modal-closer-js').forEach((button) => {
        button.addEventListener('click', this.hide.bind(this, false))      
      });
    }
  }

  customElements.define('quick-add-thank-you-modal', QuickAddThankYouModal);
});

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
   
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector('.announcement-bar-slider')) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener('change', () => {
          if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener('click', () => {
          this.announcementBarArrowButtonWasClicked = true;
        }, { once: true });
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || !this.desktopLayout.matches ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked && this.desktopLayout.matches) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateTitle();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateThumbnails();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    this.updateProductQuantity();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    // if (!this.currentVariant) return;
    // Access the hiddenVariantsImages object populated via Liquid
    const hiddenVariantsImages = window.hiddenVariantsImages;
    if (!hiddenVariantsImages || !this.currentVariant || window.isGiftProduct) return;

    const option1 = this.currentVariant?.option1;
    // Add visible slides matching the current variant
    const variantImages = hiddenVariantsImages[option1] || hiddenVariantsImages['product_image'];

    if (!variantImages) return;

    const mediaGalleryMob = document.querySelector('.splide-gallery-mob');

    if (!mediaGalleryMob) return;

    // Clear all slides in the Splide list
    const splideList = mediaGalleryMob.querySelector('.splide__list');
    if (!splideList) return;

    // Clone the first item to use it as a template
    const template = splideList.querySelector('.splide__slide')?.cloneNode(true);
    if (!template) return;

    splideList.innerHTML = '';

    Object.values(variantImages).forEach((imageData) => {
      const li = template.cloneNode(true);
      li.classList.remove('is-hidden', 'splide__slide--clone', 'is-active', 'is-visible');

      const figure = li.querySelector('figure');
      const img = document.createElement('img');
      img.src = imageData.src;
      img.widths = imageData.widths;
      img.sizes = imageData.sizes;
      img.className = imageData.classes;
      figure.innerHTML = '';
      figure.appendChild(img);
      splideList.appendChild(li);
    });

    // refresh slider
    const splidegalrefresh = new Event('splidegalrefresh');
    window.dispatchEvent(splidegalrefresh);

    // Reinitialize zoom or other features if necessary
    const initzoomer = new Event('initzoomer');
    window.dispatchEvent(initzoomer);
  }

  updateThumbnails() {
    // if (!this.currentVariant) return;
    // Access the hiddenVariantsImages object populated via Liquid
    const hiddenVariantsImages = window.hiddenVariantsImages;
    if (!hiddenVariantsImages || !this.currentVariant || window.isGiftProduct) return;

    const option1 = this.currentVariant?.option1;
    // Add visible slides matching the current variant
    const variantImages = hiddenVariantsImages[option1] || hiddenVariantsImages['product_image'];

    if (!variantImages) return;

    const mediaGalleryMob = document.querySelector('.splide-thumbnail-gallery');

    if (!mediaGalleryMob) return;

    // Clear all slides in the Splide list
    const splideList = mediaGalleryMob.querySelector('.splide__list');
    if (!splideList) return;

    // Clone the first item to use it as a template
    const template = splideList.querySelector('.splide__slide')?.cloneNode(true);
    if (!template) return;

    splideList.innerHTML = '';

    Object.values(variantImages).forEach((imageData) => {
      const li = template.cloneNode(true);
      li.classList.remove('is-hidden', 'splide__slide--clone', 'is-active', 'is-visible');

      const figure = li.querySelector('figure');
      const img = document.createElement('img');
      img.src = imageData.src;
      img.widths = imageData.widths;
      img.sizes = imageData.sizes;
      img.className = imageData.classes;
      figure.innerHTML = '';
      figure.appendChild(img);
      splideList.appendChild(li);
    });

    // refresh slider
    const splidegalrefresh = new Event('splidegalrefresh');
    window.dispatchEvent(splidegalrefresh);

    // Reinitialize zoom or other features if necessary
    const initzoomer = new Event('initzoomer');
    window.dispatchEvent(initzoomer);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false' || document.querySelector('#product-bundle')) return;
    // get selected variations
    const selectedColour = this.querySelector('[name="Colour"]:checked');
    const selectedColor = this.querySelector('[name="Color"]:checked');
    const selectedSize = this.querySelector('[name="Size"]:checked');

    // get all other variant selectors which have 'name' attribute but not Colour, Color or Size
    const otherSelectors = Array.from(
      this.querySelectorAll('[name]:checked:not([name="Colour"]):not([name="Color"]):not([name="Size"])')
    );

    function handleize(value) {
      return value
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/-$/, '')
        .replace(/^-/, '');
    }

    let varUrl = '';
    if (selectedColour) {
      varUrl = 'c:' + handleize(selectedColour.value);
    } else if (selectedColor) {
      varUrl = 'c:' + handleize(selectedColor.value);
    }

    if (selectedSize) {
      if (varUrl) {
        varUrl += ',';
      }
      varUrl += 's:' + handleize(selectedSize.value);
    }

    otherSelectors.forEach((selector, i) => {
      if (varUrl) {
        varUrl += ',';
      }
      varUrl += 's:' + handleize(selector.value);
    });

    if (varUrl && !document.querySelector('html').classList.contains('is-preview')) {
      window.history.replaceState({}, '', `${this.dataset.url}/${varUrl}`);
    } else if (document.querySelector('html').classList.contains('is-preview')) {
      var prevUrl = new URL(window.location.href);
      prevUrl.searchParams.set('variant', this.currentVariant.id);
      window.history.replaceState({}, '', `${prevUrl}`);
    } else {
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }



  updateProductQuantity() {
    if(document.getElementById('is_pre_order').value != '1') {
      return 
    }
    var currentProductVarsQty = JSON.parse(document.querySelector('#productQtyJson').textContent.replaceAll('\n', ''));
    var preQuant = currentProductVarsQty[this.currentVariant.id];
    var currentReserveQty = 0;

    if(  preQuant.reserveQty && preQuant.reserveQty != null && preQuant.reserveQty != undefined  ) {
        currentReserveQty = preQuant.reserveQty
    } 
    var currInvQtyLimit = parseInt(parseInt(preQuant.quantity) - parseInt(currentReserveQty));

    if(currInvQtyLimit <= 0 ) {
      document.getElementById('current_product_variant_qty').innerHTML = 'Sold Out';
    } else {
      document.getElementById('current_product_variant_qty').innerHTML = 'Available In Stock: ' + currInvQtyLimit;
    }
    
    
    var dataQtyInputLength = document.querySelectorAll('[data-quantity-input]').length;
    for(var i = 0; i< dataQtyInputLength; i++) {
        document.querySelectorAll('[data-quantity-input]')[i].value= 1;
       document.querySelectorAll('[data-quantity-input]')[i].setAttribute('max', currInvQtyLimit);
    }
    

    if(document.getElementById('productPriceStickyContainer')) {
      document.getElementById('productPriceStickyContainer').innerHTML = document.querySelector('.product-cta-buttons-row').innerHTML;
    }

    setTimeout(() => {
      var maxlimit = parseInt(document.querySelector('[data-quantity-input]').getAttribute('max'));
      var boolIsSoldOut = maxlimit <= 0 ? true : false
      triggerUpdatePreOrderButtons(boolIsSoldOut, maxlimit);
    }, 1000);

    document.querySelector('custom-input-number button[data-increment]').addEventListener('click', (e) => {
      let input = document.querySelector('[data-quantity-input]');
      let currentValue = parseInt(input.value);
      var maxlimit = parseInt(document.querySelector('[data-quantity-input]').getAttribute('max'));
      if (currentValue >= maxlimit) {
        triggerUpdatePreOrderButtons(true,maxlimit)
      }
    });

    document.querySelector('custom-input-number button[data-decrement]').addEventListener('click', (e) => {
      var maxlimit = parseInt(document.querySelector('[data-quantity-input]').getAttribute('max'));
      let currentValue = parseInt(document.querySelector('[data-quantity-input]')?.value);
      if (currentValue < maxlimit) {
        triggerUpdatePreOrderButtons(false,maxlimit)
      }
    });
  }

  updateTitle() {
    const checkeds = this.querySelectorAll(':checked');
    const wrapper = this.closest('.section-main-product-js') ?? this.closest('.quick-add-modal');

    if (checkeds.length) {
      checkeds.forEach((checked) => {
        // change title for each variation label
        let labels = document.querySelectorAll('[data-varcurrent="' + checked.name + '"]');
        if (labels.length) {
          labels.forEach((label) => {
            label.innerHTML = checked.value;

            // change value of duplicate radio button
            if (document.querySelector('[name="' + checked.name + '-mob"][value="' + checked.value + '"]')) {
              document.querySelector('[name="' + checked.name + '-mob"][value="' + checked.value + '"]').checked = true;
            }
            if (document.querySelector('[name="' + checked.name + '-mob2"][value="' + checked.value + '"]')) {
              document.querySelector(
                '[name="' + checked.name + '-mob2"][value="' + checked.value + '"]'
              ).checked = true;
            }

            if (label.classList.contains('sticky-bar-color-variation-js')) {
              const swatchImage = wrapper.querySelector(
                '.option-swatch-image-block-js input:checked ~ .variant-label-colour .option-swatch-image-js'
              );
              if (swatchImage) {
                const newDiv = document.createElement('div');
                newDiv.style.width = '20px';
                newDiv.style.height = '20px';
                newDiv.style.marginLeft = '8px';
                newDiv.innerHTML = swatchImage.outerHTML;
                label.appendChild(newDiv);
              }
            }
          });
        }
      });
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;

      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    if (this.closest('.quick-add-modal')) return;
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  updateProductPanelPadding(aplusproduct) {
    if (window.innerWidth < 767) {
      const panel = document.querySelector('.quick-add-modal__content-info .product-panel');
      if (panel) {
        panel.style.paddingBottom = aplusproduct ? '195px' : '110px';
      }
    }
  }

  renderProductInfo() {
    const wrapper = this.closest('.section-main-product-js') ?? this.closest('.quick-add-modal');
    if (!wrapper) return;
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    let showAjax = false;
    const isAjax = window.location.href.indexOf('bundle') > -1;
    showAjax = true;
    fetch(
      `${this.dataset.url}?${showAjax ? 'isAjax=true&' : ''}variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = wrapper.querySelectorAll(`[data-price="price-${this.dataset.section}"]`);
        if(document.querySelector('input#freegiftproduct') && html.querySelector('input#freegiftproduct')) {
          document.querySelector('input#freegiftproduct').value = html.querySelector('input#freegiftproduct').value
          document.querySelector('input#giftwithproduct').value = html.querySelector('input#giftwithproduct').value
        }else if(!document.querySelector('input#freegiftproduct') && html.querySelector('input#freegiftproduct')){
          document.querySelector("#actual-buy-btn").prepend(html.querySelector('input#giftwithproduct'))
          document.querySelector("#actual-buy-btn").prepend(html.querySelector('input#freegiftproduct'))
        }else if(document.querySelector('input#freegiftproduct') && !html.querySelector('input#freegiftproduct')){
          document.querySelector('input#freegiftproduct').remove()
          document.querySelector('input#giftwithproduct').remove()
        }
        if (document.querySelector('input#aplusproducts-cb')) {
          document.querySelector('input#aplusproducts-cb').checked = false;
        }

        if (
          html.getElementById('personalization_init_button') &&
          wrapper.querySelector('.personalization_init_button')
        ) {
          wrapper.querySelector('.personalization_init_button').innerHTML =
            html.getElementById('personalization_init_button').innerHTML;
          document
            .getElementById(`personal_image`)
            ?.setAttribute('src', html.getElementById(`personal_image`)?.getAttribute('src'));
          document
            .querySelector(`#personal_canvas .personalization_text`)
            ?.setAttribute(
              'style',
              html.querySelector(`#personal_canvas .personalization_text`)?.getAttribute('style')
            );
          const personalizeDestination = document.querySelectorAll(
            `[data-personalize-price="price-${this.dataset.section}"]`
          );
          const personalizeSource = html.getElementById(
            `personalize-price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );
          if (personalizeSource && personalizeDestination.length) {
            personalizeDestination.forEach((element) => {
              element.innerHTML = personalizeSource.innerHTML;
            });
          }
        } else if (wrapper.querySelector('.personalization_init_button')) {
          wrapper.querySelector('.personalization_init_button').innerHTML = '';
        }

        if (html.getElementById('stickyBarImage') && wrapper.querySelector('#stickyBarImage')) {
          wrapper.querySelector('#stickyBarImage').innerHTML = html.getElementById('stickyBarImage').innerHTML;
        }

        if (html.getElementById('aplusproducts') && wrapper.querySelector('#aplusproducts')) {
          wrapper.querySelector('#aplusproducts').innerHTML = html.getElementById('aplusproducts').innerHTML;
          wrapper.querySelector('#aplus_cart_price').innerHTML = html.getElementById('aplus_cart_price').innerHTML;

          const giftBoxCartPrice = wrapper.querySelector('#giftBoxCartPrice');
          const aplusGiftBoxCartPrice = wrapper.querySelector('#aplusGiftBoxCartPrice');

          if (giftBoxCartPrice) {
            giftBoxCartPrice.innerHTML = html.getElementById('giftBoxCartPrice')?.innerHTML;
          }
          if (aplusGiftBoxCartPrice) {
            aplusGiftBoxCartPrice.innerHTML = html.getElementById('aplusGiftBoxCartPrice')?.innerHTML;
          }

          if (html.getElementById('aplusproducts-cb')) {
            let aplusproducts = wrapper.querySelector('#aplusproducts-cb');

            if (!aplusproducts) {
              const buttonsRow = wrapper.querySelector('.product-cta-buttons-row');
              if (buttonsRow) {
                wrapper
                  .querySelector('.product-form__buttons')
                  ?.insertBefore(html.getElementById('aplusproducts-cb'), buttonsRow);
              }

              aplusproducts = wrapper.querySelector('#aplusproducts-cb');
            } else {
              aplusproducts.outerHTML = html.getElementById('aplusproducts-cb').outerHTML;
            }

            aplusproducts.checked = false;
            aplusproducts.addEventListener('change', (e) => {
              console.log('aplusproducts-cb', e.target.checked);
              updateVisiblePrice(e.target.closest('.product'));
            });
            this.updateProductPanelPadding(true);
          } else {
            this.updateProductPanelPadding(false);
          }
        }
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination.length) {
          destination.forEach((element) => {
            element.innerHTML = source.innerHTML;
          });
        }

        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = wrapper.querySelector(`#price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        if (wrapper.querySelector('#preorder_text')) {
          let fbt = addButtonUpdated.querySelector('span:first-child').innerHTML;
          if (fbt.toString().trim() == 'Pre Order') {
            wrapper.querySelector('#preorder_text').style = 'display:block';
          } else {
            wrapper.querySelector('#preorder_text').style.display = 'none';
          }
        }
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          addButtonUpdated.querySelector('span:first-child').innerHTML
        );

        // update bundles list

        // remove current bundle section
        if (wrapper.querySelector('#bundle-selector-wrap')) {
          wrapper.querySelector('#bundle-selector-wrap').remove();
        }

        if (html.querySelector('#bundle-selector-wrap')) {
          // add new bundle section
          wrapper
            .querySelector('#product-panel-child')
            .insertBefore(html.querySelector('#bundle-selector-wrap'), document.querySelector('#buy-buttons-wrap'));

          // lazy load images
          const lazyimg = new Event('lazyimg');
          window.dispatchEvent(lazyimg);

          checkBundleItems();
        }

        if (
          wrapper.querySelector('#personalizationColorList') != null &&
          html.querySelector('#personalizationColorList') != null
        ) {
          wrapper.querySelector('#personalizationColorList').innerHTML =
            html.querySelector('#personalizationColorList').innerHTML;

          initPersonalizeDrawers(wrapper);
        }

        if (
          wrapper.querySelector('#personalizationSelectedColorName') != null &&
          wrapper.querySelector('#personalizationSelectedColorName') != null
        ) {
          wrapper.querySelector('#personalizationSelectedColorName').innerHTML = html.querySelector(
            '#personalizationSelectedColorName'
          ).innerHTML;
        }

        // dynamic price change
        if (wrapper.querySelector('[data-dynprice]') && html.querySelector('[data-dynprice]')) {
          wrapper.querySelector('[data-dynprice]').innerHTML = html.querySelector('[data-dynprice]').innerHTML;
        }

        if (
          wrapper.querySelector('product-info[data-variantid]') &&
          html.querySelector('product-info[data-variantid]')
        ) {
          wrapper.querySelector('product-info[data-variantid]').dataset.variantid =
            html.querySelector('product-info[data-variantid]').dataset.variantid;
        }

        // variant updated
        const variantchange = new Event('variantchange');
        window.dispatchEvent(variantchange);
        console.log(this.currentVariant);
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });

        updateVisiblePrice(wrapper);
        initPriceChangeListeners(wrapper);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #bundle-actions-${this.dataset.section}`
    );
    if (!productForms) return;
    productForms.forEach((productForm) => {
      const addButtons = productForm.querySelectorAll('[name="add"], [data-bundlebtn="next"]');
      const addButtonTexts = productForm.querySelectorAll('[name="add"] > span:first-child, [data-bundlebtn="next"]');
      if (!addButtons) return;

      if (disable) {
        addButtons.forEach((btn) => btn.setAttribute('disabled', 'disabled'));

        if (text) {
          addButtonTexts.forEach((btn) => (btn.textContent = text));
        }
      } else {
        addButtons.forEach((btn) => btn.removeAttribute('disabled'));
        addButtonTexts.forEach((btn) => {
          if (btn.dataset.bundlebtn === 'next') {
            btn.textContent = 'Next';
            return;
          }
          btn.textContent = text;
        });
      }
    });

    if (!modifyClass) return;
  }

  setUnavailable() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #bundle-actions-${this.dataset.section}`
    );
    if (!productForms) return;

    //let addButtons = [];
    //let addButtonTexts = [];
    productForms.forEach((productForm) => {
      const addButtons = productForm.querySelectorAll('[name="add"], [data-bundlebtn="next"]');
      const addButtonTexts = productForm.querySelectorAll('[name="add"] > span:first-child, [data-bundlebtn="next"]');
      if (!addButtons) return;
      addButtonTexts.forEach((text) => (text.textContent = window.variantStrings.unavailable));
      //addButtonText.textContent = window.variantStrings.unavailable;
    });

    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');

        let clonedInput = document.querySelectorAll('[data-option="' + input.name + '"][value="' + input.value + '"]');
        if (clonedInput.length) {
          clonedInput.forEach((clonedInput) => clonedInput.classList.remove('disabled'));
        }
      } else {
        input.classList.add('disabled');

        let clonedInput = document.querySelectorAll('[data-option="' + input.name + '"][value="' + input.value + '"]');
        if (clonedInput.length) {
          clonedInput.forEach((clonedInput) => clonedInput.classList.add('disabled'));
        }
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      // if no inputs in fieldset, return null
      if (!fieldset.querySelectorAll('input').length) return null;

      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        console.log(div)
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


function cardColourSelector() {
  document.querySelectorAll('.product-card').forEach((card) => {
    if (card.closest('.shop-the-look-section')) {
      const productHandle = card.getAttribute('data-product-handle');
      fetch(`/products/${productHandle}.json`)
        .then((response) => response.json())
        .then((data) => {
          const variants = data.product.variants || [];
          card.dataset.variants = JSON.stringify(variants);
          initializeColourSelector(card, variants);
        })
        .catch((error) => {
          console.error(`Error loading data for ${productHandle}:`, error);
        });
    } else {
      let variants = [];
      try {
        variants = JSON.parse(card.dataset.variants || '[]');
      } catch (e) {
        console.warn('Invalid JSON in data-variants for card:', card, e);
      }
      initializeColourSelector(card, variants);
    }
  });
}

function initializeColourSelector(card, variants) {
  card.querySelectorAll('.card__colours > a:not(.ready)').forEach((el) => {
    el.classList.add('ready');
    el.addEventListener('click', function (e) {
      e.preventDefault();

      const spinner = card.querySelector('.loading-overlay__spinner');
      let fetchTemplate = el.dataset.getSlider === 'true' ? 'card-images-slider' : 'card-images';
      if (el.dataset.sliderDraggable === 'true' && el.dataset.getSlider === 'true') fetchTemplate = 'card-images-slider-draggable';


      const selectedColour = el.href.split('/c:')[1]?.toLowerCase().replace(/-/g, ' ');

      const url = el.getAttribute('href') + `?view=${fetchTemplate}`;

      if (spinner) spinner.classList.remove('hidden');

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;

          const cardImages = card.querySelector('.product-images');
          const productImages = html.querySelector('.product-images');

          if (cardImages && productImages && productImages.querySelectorAll('img').length) {
            cardImages.innerHTML = productImages.innerHTML;

            card.querySelectorAll('.card__colours > a').forEach((a) => a.classList.remove('active'));
            el.classList.add('active');

            const innerLink = card.querySelector('.card__inner a');
            const titleLink = card.querySelector('.card__content h3 a');
            if (innerLink) innerLink.setAttribute('href', el.getAttribute('href'));
            if (titleLink) titleLink.setAttribute('href', el.getAttribute('href'));

            const lazyimg = new Event('lazyimg');
            window.dispatchEvent(lazyimg);
          }

          if (variants && Array.isArray(variants)) {
            const matchingVariant = variants.find((variant) => {
              const options = [variant.option1, variant.option2, variant.option3].filter(Boolean).map((opt) => opt.toLowerCase());
              return options.includes(selectedColour);
            });
            if (matchingVariant) {
              el.closest('.card__content')?.querySelector('.variant-error-message')?.remove();
              document.getElementById('global-variant-error')?.classList.add('hidden');
              card.dataset.selectedid = matchingVariant.id;

              card.querySelectorAll('[data-product-url]').forEach((el) => {
                const url = el.dataset.productUrl
                  .split('?')[0]

                el.setAttribute('data-product-url', `${url}?variant=${matchingVariant.id}`);
              });
            }
          }
        })
        .catch((error) => {
          console.error('Error fetching new product data:', error);
        })
        .finally(() => {
          if (spinner) spinner.classList.add('hidden');
        });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  cardColourSelector();
});

window.addEventListener('initcolourselector', cardColourSelector);


function checkBundleItems() {
  // check if any bundled products are disabled
  let disabledProducts = document.querySelectorAll('#bundle-selector-wrap [data-available="false"]');
  if (disabledProducts.length > 0) {

    // diable buy button
    document.querySelector('#buy-buttons-wrap [name="add"]').setAttribute('disabled', 'disabled');
    document.querySelector('#buy-buttons-wrap [name="add"] > span:first-child').textContent = window.variantStrings.soldOut;
  }

  // add dynamic form properties
  let bundleProducts = document.querySelectorAll('#bundle-selector-wrap [data-title]');
  let dynPropsWrap = document.querySelector('#buy-buttons-wrap #add-dynamic-props');
  if (bundleProducts.length > 0 && dynPropsWrap) {

    dynPropsWrap.innerHTML = '';

    bundleProducts.forEach(function (bp) {
      let bp_title = bp.dataset.title;
      let bp_seloptions = bp.dataset.options;

      let input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', 'properties[' + bp_title + ']');
      input.setAttribute('value', bp_seloptions);
      dynPropsWrap.appendChild(input);
    });
  }
}

checkBundleItems();


// QT@8thOct2024 -- Cart Navigation - Start

document.addEventListener('DOMContentLoaded', () => {
  var checkPageIsReloaded = window.performance
    .getEntriesByType('navigation')
    .map((nav) => nav.type)
    .includes('reload');

  if (!checkPageIsReloaded && window.location.href === location.origin.toString() + '/') {
    if (document.referrer.endsWith('/cart') || document.referrer.endsWith('/cart?logged_in=true')) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.click();
      }
    } else if (document.referrer.endsWith('/account/register')) {
      // Redirecting after account creation to the account page
      window.location.href = '/account';
    }
  }
});

function triggerInput(event) {
  if(document.getElementById('is_pre_order').value != '1') {
      return 
  }
  var intMax = parseInt(event.target.getAttribute('max'));
  var intVal = parseInt(event.target.value); 
  var boolIsSoldOut = intVal >= intMax ? true : false;
   
  var count = document.querySelectorAll('.buy-quantity-input').length;
  for(var i=0;i<count;i++) {
      document.querySelectorAll('.buy-quantity-input')[i].value = intVal; 
      if(boolIsSoldOut) {
        document.querySelectorAll('.buy-quantity-input')[i].value = intMax;
      }
  }
  
  triggerUpdatePreOrderButtons(boolIsSoldOut, intMax)
}


function triggerUpdatePreOrderButtons(boolIsSoldOut, maxLimit) {
  var i = 0;
  var count = document.querySelectorAll('.buy-button-txt').length;

  if(boolIsSoldOut) {
      if(count > 0) { 
        for(i=0;i<count;i++) {
            document.querySelectorAll('.buy-button-txt')[i].innerHTML = 'Sold Out';
            document.querySelectorAll('.buy-button-product')[i].setAttribute('disabled', 'disabled');
            document.querySelectorAll('custom-input-number button[data-increment]')[i].setAttribute('disabled', 'disabled');
        } 
      }
      
      
     
  } else {
      if(count > 0) { 
        for(i=0;i<count;i++) {
            document.querySelectorAll('.buy-button-txt')[i].innerHTML = 'Pre-Order Now';
            document.querySelectorAll('.buy-button-product')[i].removeAttribute('disabled');
            if (maxLimit !== 0) {
              document.querySelectorAll('custom-input-number button[data-increment]')[i].removeAttribute('disabled');
            }
        } 
      }
      
  }
}

// QT@8thOct2024 -- Cart Navigation - End 
